<template>
  <main class="entry-layout-content"  :class="[$route.params.name && 'entry-layout-content_by_' + $route.params.name]">
    <slot />
  </main>
</template>

<script>
export default {
  name: 'EntryLayoutContent'
}
</script>

<style>
.entry-layout-content {
  flex: 1;
  min-height: 0;
  /* padding: 10px; */
  background: #f0f2f5;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
</style>
